export default [
    {
        path: 'config/list',
        name: 'sys_manage_config_list',
        meta: {isCache: false, icon: 'md-settings', hideInMenu: false},
        component: () => import('@/views/sys_manage/config/config-list.vue'),
    },
    {
        path: 'config/edit/:id',
        name: 'sys_manage_config_edit',
        meta: {isCache: false, icon: 'md-create', hideInMenu: true},
        component: () => import('@/views/sys_manage/config/config-edit.vue'),
    },
];
